/*global angular */
/*jslint node: true */

'use strict';

var padding = angular.module('msPadding', []);

var palettes;

padding.directive('msPadding', ['$templateCache', function ($templateCache) {

    // +------------------------------------------------------------------------
    // |  Hilfsfunktionen
    // +------------------------------------------------------------------------
    function stylesHaveKey(subject, key) {
        return (subject && subject.hasOwnProperty(key));
    }

    function stylesToggleKey(subject, padding) {
        subject[padding] = 100;
    }

    return {
        restrict: 'E',
        scope: {
            palettename: '=',
            subject: '=',
            fieldPadding: '='
        },
        link: function ($scope, element, attrs) {

            $scope.stylesHaveKey = stylesHaveKey;
            $scope.stylesToggleKey = stylesToggleKey;

            if ($scope.subject[$scope.fieldPadding] === undefined)
                $scope.subject[$scope.fieldPadding] = 0;

        },
        template: $templateCache.get('lib/msPadding/padding.html')
    };
}]);
